export const getSplashAssetsToLoad = () => {
	return [
		'globe'
	];
};